export default "__VITE_ASSET__b3daQ1jt__"